import generateRequest from './services/request';
import generateJavaRequest from './services/jrequest';

const request = generateRequest('goods');
const jGoodsRequest = generateJavaRequest('goods');

/**
 * 商品列表
 * @param {*} conditions
 */
export function getGoodsList(conditions) {
  return jGoodsRequest('list', conditions);
}

/**
 * 商品详情
 * @param {*} param0
 */
export function getGoodsDetail({ id }) {
  return jGoodsRequest('info', { goodsId: id });
}

/*
 * 热卖商品
 * @param {*} conditions
 */
export function getHotGoodsList(conditions) { // 热卖
  return jGoodsRequest('like', conditions);
}

/**
 * 获取商品展示详情
 * @param {*} conditions
 */
export function getGoodsViewType(conditions) {
  return jGoodsRequest('view/type', conditions);
}

/**
 * 获取专题列表
 * @param {*} conditions
 */
export function getTopicList(conditions) {
  return jGoodsRequest('special/list', conditions);
}


/**
 * 获取专题详情
 * @param {*} conditions
 */
export function getTopicDetail(conditions) {
  return jGoodsRequest('special/info', conditions);
}

/**
 * 检查商品库存
 * @param {*} conditions
 */
export function checkGoodsStock(conditions) {
  return jGoodsRequest('check/stock', conditions);
}
